import { message } from 'antd';
export const handleError = (err) => {
  message.error('An error occured.', err.response.error);
};
